import { useTranslation } from 'react-i18next';
import { Card, Fieldset, Grid, NumberInput, Select, TextInput, Title } from '@mantine/core';
import { DateTimePicker } from '@mantine/dates';
import { IconCurrencyDollar } from '@tabler/icons-react';
import PaymentConfigEnum from '../../enum/PaymentConfig';

const AddMovementForm = ({ form }: { form: any }) => {
  const { t } = useTranslation(['CashierboxesPage', 'FieldName']);

  return (
    <Fieldset>
      <Grid gutter="md">
        <Grid.Col span={12}>
          <Card>
            <Card.Section inheritPadding withBorder py="md">
              <Title order={4}> {t('CashierboxesPage:CRUD.movementInfo')}</Title>
            </Card.Section>
            <Card.Section inheritPadding py="md">
              <Grid>
                <Grid.Col span={12}>
                  <Select
                    {...form.getInputProps('type')}
                    allowDeselect={false}
                    placeholder={t('FieldName:type')}
                    label={t('FieldName:type')}
                    data={[
                      {
                        value: 'in',
                        label: t('CashierboxesPage:CRUD.movementTypeOptions.in')
                      },
                      {
                        value: 'out',
                        label: t('CashierboxesPage:CRUD.movementTypeOptions.out')
                      }
                    ]}
                  />
                </Grid.Col>
                <Grid.Col span={12}>
                  <DateTimePicker
                    {...form.getInputProps('date')}
                    dropdownType="modal"
                    label={t('FieldName:date')}
                    placeholder={t('FieldName:date')}
                  />
                </Grid.Col>
                <Grid.Col span={12}>
                  <NumberInput
                    {...form.getInputProps('amount')}
                    placeholder={t('FieldName:amount')}
                    allowLeadingZeros={false}
                    allowNegative={false}
                    label={t('FieldName:amount')}
                    rightSection={<IconCurrencyDollar />}
                  />
                </Grid.Col>
                <Grid.Col span={12}>
                  <Select
                    {...form.getInputProps('paymentMethod')}
                    allowDeselect={false}
                    placeholder={t('FieldName:paymentMethod')}
                    label={t('FieldName:paymentMethod')}
                    data={Object.values(PaymentConfigEnum).map((paymentMethod) => ({
                      value: paymentMethod,
                      label: t(`FieldName:paymentMethods.${paymentMethod}`)
                    }))}
                  />
                </Grid.Col>
                <Grid.Col span={12}>
                  <TextInput
                    {...form.getInputProps('notes')}
                    label={t('FieldName:notes')}
                    placeholder={t('FieldName:notes')}
                  />
                </Grid.Col>
              </Grid>
            </Card.Section>
          </Card>
        </Grid.Col>
      </Grid>
    </Fieldset>
  );
};

export default AddMovementForm;
